// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { HistoryFeedInfoFragmentDoc } from '../../../queries/fragments.generated';
import { ScopeHistoryDetailsFragmentDoc, ProjectItemUnitOfMeasureFragmentDoc } from './SelectionsSharedFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ProjectItemHistoryQueryVariables = Types.Exact<{
  projectItemId: Types.Scalars['ID']['input'];
}>;


export type ProjectItemHistoryQuery = { __typename?: 'Query', projectItem: { __typename?: 'ProjectItem', id: string, history: Array<{ __typename?: 'History', avatar: string, title: string, subtitle?: string | null | undefined, recordedAt: Types.Scalars['DateTime']['input'], userName?: string | null | undefined }>, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, name: string, useQuantity: boolean }, scopeHistory: Array<{ __typename?: 'ProjectItemScopeChange', costInCents: number, priceInCents: number, quantity?: number | null | undefined, tradePartnerNote?: string | null | undefined, specifications?: string | null | undefined, shortName: string }>, projectStage: { __typename?: 'ProjectStage', id: string, hasSignedContract: boolean } } };


export const ProjectItemHistoryDocument = gql`
    query ProjectItemHistory($projectItemId: ID!) {
  projectItem(id: $projectItemId) {
    id
    history {
      ...HistoryFeedInfo
    }
    unitOfMeasure {
      ...ProjectItemUnitOfMeasure
    }
    scopeHistory {
      ...ScopeHistoryDetails
    }
    projectStage {
      id
      hasSignedContract
    }
  }
}
    ${HistoryFeedInfoFragmentDoc}
${ProjectItemUnitOfMeasureFragmentDoc}
${ScopeHistoryDetailsFragmentDoc}`;

/**
 * __useProjectItemHistoryQuery__
 *
 * To run a query within a React component, call `useProjectItemHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectItemHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectItemHistoryQuery({
 *   variables: {
 *      projectItemId: // value for 'projectItemId'
 *   },
 * });
 */
export function useProjectItemHistoryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectItemHistoryQuery, ProjectItemHistoryQueryVariables> & ({ variables: ProjectItemHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectItemHistoryQuery, ProjectItemHistoryQueryVariables>(ProjectItemHistoryDocument, options);
      }
export function useProjectItemHistoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectItemHistoryQuery, ProjectItemHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectItemHistoryQuery, ProjectItemHistoryQueryVariables>(ProjectItemHistoryDocument, options);
        }
// @ts-ignore
export function useProjectItemHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectItemHistoryQuery, ProjectItemHistoryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectItemHistoryQuery, ProjectItemHistoryQueryVariables>;
export function useProjectItemHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectItemHistoryQuery, ProjectItemHistoryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectItemHistoryQuery | undefined, ProjectItemHistoryQueryVariables>;
export function useProjectItemHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectItemHistoryQuery, ProjectItemHistoryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectItemHistoryQuery, ProjectItemHistoryQueryVariables>(ProjectItemHistoryDocument, options);
        }
export type ProjectItemHistoryQueryHookResult = ReturnType<typeof useProjectItemHistoryQuery>;
export type ProjectItemHistoryLazyQueryHookResult = ReturnType<typeof useProjectItemHistoryLazyQuery>;
export type ProjectItemHistorySuspenseQueryHookResult = ReturnType<typeof useProjectItemHistorySuspenseQuery>;
export type ProjectItemHistoryQueryResult = ApolloReactCommon.QueryResult<ProjectItemHistoryQuery, ProjectItemHistoryQueryVariables>;